// import { ToolbarButton, ToolbarSeparator } from '@robotsnacks/ui';
import React, { SFC } from 'react';
import BlockToolbar, { BlockToolbarProps } from '../BlockToolbar';
import DeleteBlockFlyout from '../DeleteBlockFlyout';

type Props = { onDeleteClick?: () => void } & Pick<
  BlockToolbarProps,
  'block' | 'parentItems'
>;

const TITLE = 'Event';

const EventBlockToolbar: SFC<Props> = ({ onDeleteClick, ...rest }) => (
  <BlockToolbar title={TITLE} {...rest}>
    <DeleteBlockFlyout onDeleteClick={onDeleteClick} title={TITLE} />
    {/* <ToolbarSeparator /> */}
    {/* <ToolbarButton>
      <Icon>action:settings</Icon>
    </ToolbarButton> */}
  </BlockToolbar>
);

EventBlockToolbar.displayName = 'RichTextBlockToolbar';

export default EventBlockToolbar;
